import React from "react";
import sharedStyles from "../styles/SharedStyles.module.css";
import caveCeiling from "../assets/cave_ceiling.png";

const Room13 = ({ goToRoom13b, goBack }) => {
  return (
    <div className={sharedStyles.centeredContainer}>
      <h1 className={sharedStyles.pageTitle}>Unnamed Chamber</h1>
      <p className={sharedStyles.pageDescription}>
        The walls here are uneven, carved by time and unseen forces.
      </p>

      <div className={sharedStyles.sceneContainer}>
        {/* Room Image */}
        <img
          src={caveCeiling}
          alt="Cave Room"
          className={sharedStyles.sceneImage}
        />

        {/* Path Button */}
        <button
          className={sharedStyles.button}
          style={{ top: "5%", left: "50%", position: "absolute" }}
          onClick={goToRoom13b}
        >
          Up
        </button>
      </div>

      {/* Go Back Button */}
      <button className={sharedStyles.backButton} onClick={goBack}>
        ← Go Back
      </button>
    </div>
  );
};

export default Room13;